import { ServerFetch } from '../main-model'

export default class StockChangeOutListModel extends ServerFetch {
    getStockChangeOutListBy = (data) => this.authFetch({
        url: 'stock-change-out-list/getStockChangeOutListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}